// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".two-fa-prompt{border-radius:20px;position:relative}.two-fa-prompt h1,.two-fa-prompt p{color:var(--g-text-primary)}.two-fa-prompt .close-icon{cursor:pointer;position:absolute!important;right:12px;top:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
